import { format, parseISO } from "date-fns";
import type { ActivityFeedEntry } from "./types";

export type ActivityFeedDayGroup = {
  dayKey: string;
  dayLabel: string;
  entries: ActivityFeedEntry[];
};

// Entries keep their input order within a day, so callers pass them newest-first.
export function groupEntriesByDay(entries: ActivityFeedEntry[]): ActivityFeedDayGroup[] {
  const groupsByKey = new Map<string, ActivityFeedDayGroup>();

  for (const entry of entries) {
    const date = parseISO(entry.timestamp);
    const dayKey = format(date, "yyyy-MM-dd");

    let group = groupsByKey.get(dayKey);
    if (!group) {
      group = { dayKey, dayLabel: format(date, "MMMM d, yyyy"), entries: [] };
      groupsByKey.set(dayKey, group);
    }
    group.entries.push(entry);
  }

  return [...groupsByKey.values()].sort((a, b) => (a.dayKey < b.dayKey ? 1 : -1));
}
